import { gsap } from 'gsap';

// import { GSDevTools } from 'gsap/GSDevTools';
// gsap.registerPlugin(GSDevTools);

export default function anleitung() {
  const mm = gsap.matchMedia();

  mm.add('(min-width: 960px)', () => {
    gsap.set('#liane6', {
      drawSVG: 0
    });

    gsap.fromTo(
      '#liane6',
      { drawSVG: 0 },
      {
        drawSVG: '100%',
        ease: 'none',
        scrollTrigger: {
          trigger: '#abw_section_4',
          pin: false,
          scrub: true,
          start: 'top 50%',
          end: 'bottom 50%'
          // onRefresh: (self) => self.progress && self.animation.progress(1),
          // markers: true,
          // id: 'abw_section_4'
        }
      }
    );

    gsap.set('#abw_section_4_h2_firstline, #abw_section_4_h2_secondline', {
      opacity: 0,
      yPercent: '20'
    });

    gsap.set('.aw_grid_item', {
      opacity: 0,
      yPercent: '100'
    });

    gsap
      .timeline({
        defaults: {
          opacity: 1,
          yPercent: '0',
          duration: 0.5,
          ease: 'none'
        },
        scrollTrigger: {
          trigger: '#abw_section_4',
          scrub: false,
          pin: false,
          // onRefresh: (self) => self.progress && self.animation.progress(1),
          start: 'top 50%',
          end: 'bottom 50%',
          toggleActions: 'play none none reverse'
        }
      })
      // .fromTo(
      //   '#liane6',
      //   { drawSVG: 0 },
      //   { drawSVG: '100%', duration: 6.25, ease: 'none' },
      //   0
      // )

      .to('#abw_section_4_h2_firstline', {}, 0)
      .to('#abw_section_4_h2_secondline', {}, 0.25)
      .to('.aw_grid_item:nth-child(1)', {}, 1)
      .to('.aw_grid_item:nth-child(2)', {}, 1.25)
      .to('.aw_grid_item:nth-child(3)', {}, 1.5)
      .to('.aw_grid_item:nth-child(4)', {}, 1.75)

      .to('.aw_grid_item:nth-child(5)', {}, 2)
      .to('.aw_grid_item:nth-child(6)', {}, 2.25)
      .to('.aw_grid_item:nth-child(7)', {}, 2.5)
      .to('.aw_grid_item:nth-child(8)', {}, 2.75);
  });

  // Mobile
  mm.add('(max-width: 959px)', () => {
    gsap.set('#liane6', {
      drawSVG: 0
    });

    gsap.fromTo(
      '#liane6',
      { drawSVG: 0 },
      {
        drawSVG: '100%',
        ease: 'none',
        scrollTrigger: {
          trigger: '#abw_section_4',
          pin: false,
          scrub: true,
          start: 'top 50%',
          // endTrigger: '#abw_section_5',
          end: 'bottom 50%'
          // onRefresh: (self) => self.progress && self.animation.progress(1),
          // markers: true,
          // id: 'abw_section_4'
        }
      }
    );
  });

  // GSDevTools.create({ animation: tl });
}
